import type {ChangeId} from '../../../../../../types'
import {stringifyId} from '../../../../../../types'

export const getChangeTestsTreeLocator = (
  changeId: ChangeId,
  personal: boolean | undefined | null,
) => `id:${stringifyId(changeId)},personal:${personal || false}`
